import * as employeesTypes from './employeesTypes';

const initialState = {
  dynamicContent: {},
  isLoading: false,
  relatedTabs: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case employeesTypes.GET_EMPLOYEE_DETAIL_SUCCESS:
      return {
        ...state,
        dynamicContent: {
          pageElements: action.payload.pageElements,
          lookUps: action.payload.lookUps,
        },
        relatedTabs: action.payload.relatedTabs,
      };

    case employeesTypes.LOADING_EMPLOYEE: {
      return {
        ...state,
        isLoading: action.isLoading,
      };
    }

    default:
      return state;
  }
};
